import { writable } from "svelte/store";

/**
 * DR building constructor (task #81 Track 3b) shared state. The
 * BuildingEditorTool drags a footprint and sets it here; the BuildingEditor
 * side panel reads it, collects materials, and confirms. Footprint units are
 * TILES (the compiler's BuildingRecord x/y/width/depth), matching the 32px
 * world-tile snap.
 */
export interface BuildingFootprint {
  x: number;
  y: number;
  width: number;
  depth: number;
}

/** The footprint the staff member just dragged, awaiting material choices, or
 * null when nothing is pending (panel shows the "drag a footprint" hint). */
export const pendingBuildingFootprintStore = writable<BuildingFootprint | null>(null);
